
import React, { useEffect, useState } from 'react'

import axios, { AxiosError } from 'axios';
import Avatar from '../common/Avatar';
import { BASEURL } from "../../constants";
import moment from 'moment';
import { Bounce, toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const initialState = {
    firstName: "",
    lastName: "",
    dob: null,
    mobile: "",
    email: "",
    localAddressLine1: "",
    localAddressLine2: "",
    localAddressLine3: "",
    mailingAddressLine1: "",
    mailingAddressLine2: "",
    mailingAddressLine3: "",
    lSuburbID: 0,
    avetmissSuburbID: 0,
    lSuburb: "",
    lState: "",
    lPostCode: "",
    lCountry: "",
    mSuburbID: 0,
    mSuburb: "",
    mState: "",
    mPostCode: "",
    mCountry: "",
    propertyName: "",
    flatDetail: "",
    streetName: "",
    streetNo: ""
};


const UserProfileForm = () => {

    const studentId = localStorage.getItem("studentId");
    const studentName = localStorage.getItem("studentName");

    const [loading,setLoading] = useState(false);
    const [submitLoading,setSubmitLoading] = useState(false);


    const [formState, setFormState] = useState(initialState);
    const [originalState, setOriginalState] = useState(initialState);
    const [suburbLoading, setSuburbLoading] = useState({ local: false, mailing: false });
    const [suburbText, setSuburbText] = useState({ local: "", mailing: "" });
    const [selectedSuburbs, setSelectedSuburbs] = useState({ local: null, mailing: null });
    const [suburbs, setSuburbs] = useState([]);
    
    const getdata = async () => {
        setLoading(true);        
        try {
            const res = await axios.get(BASEURL + "Student/Address/" + localStorage.getItem("studentId"));

            const data = res.data[0];
            if (data) {
                const mappedState = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    dob: data.dob ? moment(data.dob, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                    mobile: data.mobile,
                    email: data.email,
                    localAddressLine1: data.localAddressLine1,
                    localAddressLine2: data.localAddressLine2,
                    localAddressLine3: data.localAddressLine3,
                    mailingAddressLine1: data.mailingAddressLine1,
                    mailingAddressLine2: data.mailingAddressLine2,
                    mailingAddressLine3: data.mailingAddressLine3,
                    lSuburbID: data.localSuburbID,
                    lSuburb: data.localSuburb,
                    lState: data.localState,
                    lPostCode: data.localPostCode,
                    lCountry: data.localCountry,
                    mSuburbID: data.mailingSuburbID,
                    mSuburb: data.mailingSuburb,
                    mState: data.mailingState,
                    mPostCode: data.mailingPostCode,
                    mCountry: data.mailingCountry,
                    propertyName: data.propertyName,
                    flatDetail: data.flatDetail,
                    streetName: data.streetName,
                    streetNo: data.streetNo
                };
        
                setFormState(mappedState);
                setOriginalState(mappedState);
        
                setSelectedSuburbs({
                    local: data.localSuburbID > 0 ? {
                        suburbID: data.localSuburbID,
                        name: data.localSuburb,
                        postCode: data.localPostCode,
                        state: data.localState,
                        country: data.localCountry
                    } : null,
                    mailing: data.mailingSuburbID > 0 ? {
                        suburbID: data.mailingSuburbID,
                        name: data.mailingSuburb,
                        postCode: data.mailingPostCode,
                        state: data.mailingState,
                        country: data.mailingCountry
                    } : null
                });
            }

            const { data: req } = await axios.get(BASEURL + "Student/ChangeStudentInformation/LastRequest/" + localStorage.getItem("studentId"));            

            let key = `showLastReqStatus_${req.studentChangeInformationId}`;

            if (req.status !== 0 && localStorage.getItem(key) === null) {
                
                // clearing all the previous request
                Object.keys(localStorage).forEach((key) => {
                    if (key.startsWith("showLastReqStatus_")) {
                        localStorage.removeItem(key);
                    }
                });

                localStorage.setItem(key, "false");
            }
            
            const showStatus = (req.status === 1 || req.status === 2) && localStorage.getItem(key) !== "true";

            if (showStatus) {
                const toastOptions = {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                    onClose: () => {
                        localStorage.setItem(key, "true");
                    }
                };
    
                if (req.status === 1) {
                    toast.success('Your last request was Approved', toastOptions);
                } else if (req.status === 2) {
                    toast.error('Your last request was Declined', toastOptions);
                }
            }
        
            
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    const getSuburb = async (text, type) => {

        if(text.trim() === "") return setSuburbs([]);

        setSuburbLoading((prev) => ({ ...prev, [type]: true }));    
        
        
        try {
            const res = await axios.get(BASEURL + "Suburb/getSuburb?searchText=" + text);
            setSuburbs(res.data)
        } catch (error) {
            console.log(error)
        } finally {
            setSuburbLoading((prev) => ({ ...prev, [type]: false }));
        }
    }

    useEffect(() => {
        let timeout = setTimeout(() => {
            getSuburb(suburbText.local, "local")
        }, 800);

        return () => clearTimeout(timeout);
    }, [suburbText.local])

    useEffect(() => {
        let timeout = setTimeout(() => {
            getSuburb(suburbText.mailing, "mailing")
        }, 800);

        return () => clearTimeout(timeout);
    }, [suburbText.mailing])

    useEffect(() => {
        getdata();
    }, [])


    const trimObjectStrings = (obj) => {
        const trimmed = {};
        for (const key in obj) {
            const value = obj[key];
            if (typeof value === 'string') {
                trimmed[key] = value.trim();
            } else {
                trimmed[key] = value;
            }
        }
        return trimmed;
    };

    const handleSubmit = async () => {

        if(!formState.dob || !formState.email?.trim()){
            return toast.error("Dob and Email fields are required");
        }

        // validations
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formState.email.trim())) {
            return toast.error("Please enter a valid email address");
        }

        // Remove everything except digits
        const cleaned = formState.mobile?.replace(/[^\d]/g, '');
        const mobileRegex = /^\d{10,15}$/;
        if (!mobileRegex.test(cleaned)) {
            return toast.error("Please enter a valid mobile number");
        }


        setSubmitLoading(true);
    
        try {
            const flat = formState?.flatDetail?.trim() || "";
            const streetNo = formState?.streetNo?.trim() || "";
            const streetName = formState?.streetName?.trim() || "";
            const propertyName = formState?.propertyName?.trim() || "";
    
            const tempAddr = `${flat}${flat && streetNo ? `/${streetNo}` : ""} ${streetName}`.trim();
            const localAddr1 = propertyName || tempAddr;
            const localAddr2 = propertyName ? tempAddr : "";
    
            const selectedLocalSuburb = selectedSuburbs?.local || {};
            const selectedMailingSuburb = selectedSuburbs?.mailing || {};

            const areLocalFieldsModified = (originalState.propertyName !== formState.propertyName) || (originalState.flatDetail !== formState.flatDetail) || (originalState.streetNo !== formState.streetNo) || (originalState.streetName !== formState.streetName);
    
            const updatedFormState = {
                ...formState,
                localAddressLine1: areLocalFieldsModified ? localAddr1 : originalState.localAddressLine1,
                localAddressLine2: areLocalFieldsModified ? localAddr2 : originalState.localAddressLine2,
    
                lSuburbID: selectedLocalSuburb.suburbID || 0,
                lSuburb: selectedLocalSuburb.name || "",
                lState: selectedLocalSuburb.state || "",
                lPostCode: selectedLocalSuburb.postCode || "",
                lCountry: selectedLocalSuburb.country || "",
                avetmissSuburbID: selectedLocalSuburb.suburbID || 0,
    
                mSuburbID: selectedMailingSuburb.suburbID || 0,
                mSuburb: selectedMailingSuburb.name || "",
                mState: selectedMailingSuburb.state || "",
                mPostCode: selectedMailingSuburb.postCode || "",
                mCountry: selectedMailingSuburb.country || "",
            };

            originalState.avetmissSuburbID = selectedLocalSuburb.suburbID || 0;
    
            // const isModified = JSON.stringify(updatedFormState) !== JSON.stringify(originalState);
            const isModified = JSON.stringify(trimObjectStrings(updatedFormState)) !== JSON.stringify(trimObjectStrings(originalState));
    
            if (!isModified) {
                toast.warn("Change something to update");
                return;
            }
    
            setFormState(updatedFormState);

            if(!window.confirm("Note: Your details will only be updated once the college faculty reviews and approves your request. Please double-check all information before submitting.")){
                return
            }
    
            const res = await axios.post(
                BASEURL + "Student/ChangeStudentInformation/" + localStorage.getItem("studentId"),
                updatedFormState
            );
    
            toast.success("Request submitted successfully");
        } catch (error) {
            if (error instanceof AxiosError) {
                if(typeof error.response?.data !== "string"){
                    toast.error("Invalid data");
                }else{
                    toast.error(error.response?.data || "Submission failed");
                }
            } else {
                console.error(error);
                toast.error("Unable to submit request");
            }
        } finally {
            setSubmitLoading(false);
        }
    };
    

    const copyAddress = (isChecked) => {
        const flat = formState?.flatDetail?.trim() || "";
        const streetNo = formState?.streetNo?.trim() || "";
        const streetName = formState?.streetName?.trim() || "";
        const propertyName = formState?.propertyName?.trim() || "";
    
        const tempAddr = `${flat}${flat && streetNo ? `/${streetNo}` : ""} ${streetName}`.trim();
    
        const mailingAddr1 = propertyName ? propertyName : tempAddr;
        const mailingAddr2 = propertyName ? tempAddr : "";
        

        if(isChecked){
            setFormState({
                ...formState,
                mailingAddressLine1: mailingAddr1?.trim(),
                mailingAddressLine2: mailingAddr2?.trim()
            });

            setSelectedSuburbs({...selectedSuburbs, mailing: selectedSuburbs.local})
        }else{
            setFormState({
                ...formState,
                mailingAddressLine1: originalState.mailingAddressLine1,
                mailingAddressLine2: originalState.mailingAddressLine2
            });

            let mailing = {
                suburbID: originalState.mSuburbID,
                name: originalState.mSuburb,
                postCode: originalState.mPostCode,
                state: originalState.mState,
                country: originalState.mCountry
            }

            setSelectedSuburbs({...selectedSuburbs, mailing: mailing})
        }
    };
    
    

    if(loading) {
        return <div style={{marginTop: "10rem", display: "grid", placeContent: "center"}}><p>Loading...</p></div>
    }


  return (
    <div className="max-w-6xl mx-auto p-8">
        {/* Profile Header */}
        <div className='flex items-start justify-between'>
            <div className="flex items-center gap-6 mb-10">
                <Avatar className="rounded-full w-20 h-20" url={`https://ui-avatars.com/api/name=${studentName}/?background=random`} />
                <div>
                    <h2 className="text-2xl font-semibold text-gray-800">{originalState.firstName} {originalState.lastName}</h2>
                    <p className="text-sm text-gray-500">{originalState.email}</p>
                    <p className="text-sm text-gray-500">Mobile: {originalState.mobile}</p>
                </div>
            </div>

            <button disabled={submitLoading} onClick={handleSubmit} className="flex items-center gap-2 px-4 py-1.5 bg-blue-600 text-sm text-white font-medium rounded-lg shadow hover:bg-blue-700 transition duration-150">
                {submitLoading && <AiOutlineLoading3Quarters  className="w-4 h-4 fill-white animate-spin"/>}
                Request Changes
            </button>
        </div>

        {/* Personal Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth <span className='text-red-500'>*</span></label>
                <input
                    type="date"
                    defaultValue={formState.dob}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    onChange={(e) => setFormState({...formState, dob: e.target.value})}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email <span className='text-red-500'>*</span></label>
                <input
                    defaultValue={formState?.email}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    onChange={(e) => setFormState({...formState, email: e.target.value})}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
                <input
                    defaultValue={formState?.mobile}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    onChange={(e) => setFormState({...formState, mobile: e.target.value})}
                />
            </div>
        </div>


        {/* Address Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Local Address */}
            <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-1">Local Address</h3>

                <div className='mb-4'>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Building / Property Name</label>
                    <input
                        defaultValue={formState?.propertyName}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, propertyName: e.target.value})}
                    />
                </div>
                
                <div className='mb-4'>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Flat / Unit Detail</label>
                    <input
                        defaultValue={formState?.flatDetail}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, flatDetail: e.target.value})}
                    />
                </div>

                <div className='mb-4'>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Street No</label>
                    <input
                        defaultValue={formState?.streetNo}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, streetNo: e.target.value})}
                    />
                </div>

                <div className='mb-4'>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Street Name</label>
                    <input
                        defaultValue={formState?.streetName}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, streetName: e.target.value})}
                    />
                </div>

                {selectedSuburbs.local === null ? (
                    <div className="mb-4 relative">

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Suburb</label>

                            <div className='relative'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-4 absolute left-2 top-3">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                </svg>

                                <input
                                    // defaultValue={value}
                                    className="w-full pl-8 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    onChange={(e) => setSuburbText({...suburbText, local: e.target.value})}
                                />
                            </div>
                        </div>

                        {suburbText?.local.trim() !== "" && <div className='w-full max-h-40 bg-white shadow rounded-lg absolute overflow-hidden overflow-y-auto'>
                            {suburbLoading.local ? (
                                <div className='p-4 text-sm text-gray-500'>Loading...</div>
                            ) : suburbs.length === 0 ? (
                                <div className='p-4 text-sm text-gray-500'>No suburbs found</div>
                            ) : (
                                <ul className='divide-y-2 divide-gray-100'>
                                    {suburbs.map((item, index) => (
                                        <li
                                            key={index}
                                            className='px-4 py-2 cursor-pointer text-sm hover:bg-gray-50 transition-colors'
                                            onClick={() => {
                                                setSuburbText({...suburbText, local: ""})
                                                setSelectedSuburbs({...selectedSuburbs, local: item});
                                                setSuburbs([]);
                                            }}
                                        >
                                            <p className='font-medium text-gray-800'>{item.name}</p>

                                            <div className='text-gray-500 text-xs flex gap-2'>
                                                <span>{item.postCode}</span>
                                                <span>{item.state}</span>
                                                <span>{item.country}</span>
                                            </div>
                                        </li>                                  
                                    ))}
                                </ul>
                            )}
                        </div>}

                    </div>
                ) : (
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Suburb</label>

                        <div className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between">
                            <p>{selectedSuburbs?.local?.name}</p>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5 cursor-pointer text-gray-500" onClick={() => setSelectedSuburbs({...selectedSuburbs, local: null})}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                        </div>
                    </div>
                )}

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.local?.state}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Postcode</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.local?.postCode}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.local?.country}</p>
                </div>
            </div>

            {/* Mailing Address */}
            <div>
                <h3 className="mb-4 border-b pb-1 flex items-center gap-4">
                    <p className='text-lg font-semibold text-gray-800 '>Mailing Address</p>

                    <div className='flex items-center gap-1.5'>
                        <input id='sameAsAddr' type='checkbox' className='h-4 w-4 cursor-pointer' onClick={(e) => copyAddress(e.target.checked)}/>
                        <label htmlFor='sameAsAddr' className='text-sm cursor-pointer'>Same as Local Address</label>
                    </div>
                </h3>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 1</label>
                    <input
                        value={formState?.mailingAddressLine1 || ""}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, mailingAddressLine1: e.target.value})}
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 2</label>
                    <input
                        value={formState?.mailingAddressLine2 || ""}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, mailingAddressLine2: e.target.value})}
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 3</label>
                    <input
                        value={formState?.mailingAddressLine3 || ""}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormState({...formState, mailingAddressLine3: e.target.value})}
                    />
                </div>

                {selectedSuburbs.mailing === null ? (
                    <div className="mb-4 relative">

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Suburb</label>

                            <div className='relative'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-4 absolute left-2 top-3">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                </svg>

                                <input
                                    // defaultValue={value}
                                    className="w-full pl-8 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    onChange={(e) => setSuburbText({...suburbText, mailing: e.target.value})}
                                />
                            </div>
                        </div>

                        {suburbText.mailing.trim() !== "" && <div className='w-full max-h-40 bg-white shadow rounded-lg absolute overflow-hidden overflow-y-auto'>
                            {suburbLoading.mailing ? (
                                <div className='p-4 text-sm text-gray-500'>Loading...</div>
                            ) : suburbs.length === 0 ? (
                                <div className='p-4 text-sm text-gray-500'>No suburbs found</div>
                            ) : (
                                <ul className='divide-y-2 divide-gray-100'>
                                    {suburbs.map((item, index) => (
                                        <li
                                            key={index}
                                            className='px-4 py-2 cursor-pointer text-sm hover:bg-gray-50 transition-colors'
                                            onClick={() => {
                                                setSuburbText({...suburbText, mailing: ""})
                                                setSelectedSuburbs({...selectedSuburbs, mailing: item});
                                                setSuburbs([]);
                                            }}
                                        >
                                            <p className='font-medium text-gray-800'>{item.name}</p>

                                            <div className='text-gray-500 text-xs flex gap-2'>
                                                <span>{item.postCode}</span>
                                                <span>{item.state}</span>
                                                <span>{item.country}</span>
                                            </div>
                                        </li>                                  
                                    ))}
                                </ul>
                            )}
                        </div>}

                    </div>
                ) : (
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Suburb</label>

                        <div className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between">
                            <p>{selectedSuburbs?.mailing?.name}</p>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5 cursor-pointer text-gray-500" onClick={() => setSelectedSuburbs({...selectedSuburbs, mailing: null})}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                        </div>
                    </div>
                )}

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.mailing?.state}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Postcode</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.mailing?.postCode}</p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
                    <p className="w-full px-4 h-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50">{selectedSuburbs?.mailing?.country}</p>
                </div>
            </div>
        </div>

    </div>

  )
}

export default UserProfileForm
